import { notification } from 'antd'
import React from 'react'

import { CheckCircleIcon, CloseCircleIcon, ExclamationCircleIcon, InfoCircleIcon } from '../../icons'
import theme from '../../theme'
import { Wrapper } from './styles'

enum NotificationType {
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
}

type notifyProps = {
  type?: NotificationType
  message: string
  description: string
}

const notify = ({ type, message, description }: notifyProps) => {
  let icon: React.ReactElement
  let styles: React.CSSProperties = {
    boxShadow: '0px 10px 15px rgba(0, 0, 0, 0.08), 0px 4px 6px rgba(0, 0, 0, 0.03)',
    borderRadius: '2px',
  }

  switch (type) {
    case NotificationType.SUCCESS:
      icon = <CheckCircleIcon style={{ color: theme.colors.green5 }} />
      styles = { ...styles, background: theme.colors.green1, border: `1px solid ${theme.colors.green3}` }
      break
    case NotificationType.WARNING:
      icon = <ExclamationCircleIcon style={{ color: theme.colors.yellow7 }} />
      styles = { ...styles, background: theme.colors.yellow1, border: `1px solid ${theme.colors.yellow3}` }
      break
    case NotificationType.ERROR:
      icon = <CloseCircleIcon style={{ color: theme.colors.red6 }} />
      styles = { ...styles, background: theme.colors.red1, border: `1px solid ${theme.colors.red3}` }
      break
    case NotificationType.INFO:
      icon = <InfoCircleIcon style={{ color: theme.colors.blue5 }} />
      styles = { ...styles, border: `1px solid ${theme.colors.blue3}` }
      break
    default:
      icon = <InfoCircleIcon style={{ color: theme.colors.blue5 }} />
      styles = { ...styles, border: `1px solid ${theme.colors.blue3}` }
  }

  const styledMessage = (
    <Wrapper id="nova-shared-Toast-message" variant="bold">
      {message}
    </Wrapper>
  )
  const styledDescription = <Wrapper id="nova-shared-Toast-description">{description}</Wrapper>

  if (type) {
    notification[type]({
      message: styledMessage,
      description: styledDescription,
      placement: 'top',
      duration: 3,
      icon: icon,
      style: styles,
    })
  } else
    notification.open({
      message: styledMessage,
      description: styledDescription,
      placement: 'top',
      duration: 3,
      icon: icon,
      style: styles,
    })
}

export { notify, NotificationType }
